module.exports = __webpack_public_path__ + "logo-stripe.ef0ba386aed0de3678b0782c54f02b41.svg";